import {Component, OnInit} from '@angular/core';
import {MdDialog, MdDialogRef} from '@angular/material';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';
import {AppComponent} from './app.component';
import {TransactionsService} from './transactions.service';
import {ProductsArticleService} from './products-article.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

import {InventoryService} from './inventory.service';

@Component({
    selector: 'dashboard',
    styleUrls: ['./styles/dashboard.component.css','./styles/iconfont/material-icons.css'],
    templateUrl: './templates/dashboard.component.html',
    providers: [AuthentificationService, TransactionsService, ProductsArticleService, SortTable, InventoryService]
})


export class DashboardComponent {
    name = 'Dashboard';
    invalid_list: Array<any>;
    art_list: Array<any>;
    article_selected_list: Array<string> = [];
    article_list: Array<string> = [];
    empty_list: boolean = true;
    tododelivery_list: Array<string> = [];
    docket_list: Array<string> = [];
    sortedDataArtcile: any = [];
    sortedDataNotValidatePurchase: any = [];
    sortedDataToDoDeliveryClientList: any = [];
    sortedDataMovementHistoryList: any = [];

    stock_alerte: any = 0;
    dlc_alerte: any = 0;
    validation_da: any = 0;
    to_do_delivery_c: any = 0;
    current_delivery_c: any = 0
    current_bcf: any = 0;

    options = {
        weekday: "long", year: "numeric", month: "short",
        day: "numeric"//, hour: "2-digit", minute: "2-digit"  
    };
    date_now = new Date().toLocaleDateString("fr-FR", this.options);

    constructor(private router: Router,
        private authentification_service: AuthentificationService,
        private app_component: AppComponent,
        private transactions_service: TransactionsService,
        private product_service: ProductsArticleService,
        private sort_table: SortTable,
        private inventory_service: InventoryService) {
        this.CheckUSerSession();
    }

    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    GetNotValidatePurchaseList(): void {
        this.transactions_service.GetNotValidatePurchaseList().then(result => {this.invalid_list = result['list']; this.sortedDataNotValidatePurchase = result['list']; this.validation_da = result['list'].length});
    }

    SortNotValidatePurchaseList(sort: Sort): void {
        this.sort_table.SetDataArray(this.invalid_list, [{value: "date", type: ""}, {value: "name", type: ""}, {value: "applicant", type: ""}]);
        this.sort_table.sortData(sort);
        this.sortedDataNotValidatePurchase = this.sort_table.GetSortData();
        // recupérer  data
    }
    GetArticlesStockInfThershold(): void {
        this.product_service.GetArticleWhoStockInfOfThershold().then(result => {this.art_list = result['list']; this.article_list = result['list']; this.sortedDataArtcile = result['list']; this.ArticleAlerte(result['list'])});
    }

    ArticleAlerte(list: any): void {
        for (let i = 0; i < list.length; i++) {
            //console.log(list[i]);

            if (parseInt(list[i]['stock']) <= parseInt(list[i]['supply_thershold'])) {
                this.stock_alerte = this.stock_alerte + 1;
            }

            if (list[i]['dlc'] === "périmé") {
                this.dlc_alerte = this.dlc_alerte + 1;
            }
        }
    }

    SortArticlesStockInfThershold(sort: Sort): void {
        this.sort_table.SetDataArray(this.art_list, [{value: "name", type: ""}, {value: "stock", type: "number"}, {value: "supply_thershold", type: "number"}, {value: "DLC", type: ""}]);
        this.sort_table.sortData(sort);
        this.sortedDataArtcile = this.sort_table.GetSortData();
        // recupérer  data
    }

    ValidatePurchase(purchase: any): void {
        this.router.navigate(['purchasing-list', {id_transaction_details: purchase.id_transaction_details}]);
    }



    setStyles(art: any) {
        let styles = {
            'color': 'red',
        };
        if (parseInt(art.stock) != 0) {
            if (parseInt(art.stock) >= parseInt(art.supply_thershold)) {
                styles = {'color': 'black'};
            } else {
                styles = {'color': 'orange'};
            }
        }
        return styles;
    }

    setStylesDate(art: any) {
        let styles = {
            'color': 'black',
        };
        //console.log(art.dlc);
        if (art.dlc === "périmé") {
            styles = {'color': 'red'};
        }
        return styles;
    }

    isChecked(): boolean {
        return this.article_selected_list.length === this.article_list.length;
    }

    isIndeterminate(): boolean {
        return (this.article_selected_list.length !== 0 &&
            this.article_selected_list.length !== this.article_list.length);

    }

    toggleAll(): void {

        if (this.article_selected_list.length === this.article_list.length) {
            this.article_selected_list = [];
            this.empty_list = true;
        } else if (this.article_selected_list.length === 0 || this.article_selected_list.length > 0) {
            this.empty_list = false;
            for (let i = 0; i < this.article_list.length; i++) {
                this.article_selected_list[i] = this.article_list[i]['id_article'];

            }
        }
        // this.quantity = this.article_selected_list.length;
    }

    Exists(id_article: string, selected: Array<string>): boolean {
        return selected.indexOf(id_article) > -1;
    }

    Toggle(id_article: string, selected: Array<string>): void {
        this.empty_list = false;

        var index = selected.indexOf(id_article);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(id_article);
        }
        if (this.article_selected_list.length === 0) {
            this.empty_list = true;
        }
        //this.quantity = selected.length;
    };

    Approvissionner(): void {
        /*console.log(this.article_selected_list);
        console.log(this.article_selected_list.join('_'));*/

        let checked_list = this.article_selected_list.join('_');
        this.transactions_service.ApprFromDashboard(checked_list).then(result => {this.router.navigate(['purchasing-order', {transaction_name: 'Approvisionnement'}]);});
    }

    ShowDetailsOutOfOrder(out_of_order: any): void {
        this.router.navigate(['out-from-out-of-ware', {id_transaction_details: out_of_order.id_transaction_details}]);
    }

    //    GetValidateOutofWareList(): void {
    //        //this.transactions_service.GetValidatePurchaseList().then(result => {this.tododelivery_list = result['list']});
    //        this.transactions_service.GetValidateOutOfWareList().then(result => {this.tododelivery_list = result['list']; this.sortedDataToDoDeliveryClientList = result['list']});
    //    }
    SortToDoDeliveryList(sort: Sort): void {
        this.sort_table.SetDataArray(this.tododelivery_list, [{value: "date", type: ""}, {value: "ref", type: ""}, {value: "client", type: ""}, {value: "applicant", type: ""}, {value: "delivery_date", type: ""}]);
        this.sort_table.sortData(sort);
        this.sortedDataToDoDeliveryClientList = this.sort_table.GetSortData();
        // recupérer  data
    }
    GetMovementHistoryList(): void {
        this.transactions_service.GetMovementHistoryList().then(result => {this.docket_list = result['list']; this.sortedDataMovementHistoryList = result['list']});
    }

    SortMovementHistoryList(sort: Sort): void {
        this.sort_table.SetDataArray(this.docket_list, [{value: "timestamp", type: ""}, {value: "reference_code", type: ""}, {value: "docket_name", type: ""}, {value: "operation", type: ""}, {value: "motif", type: ""}, {value: "antecedent", type: ""}]);
        this.sort_table.sortData(sort);
        this.sortedDataMovementHistoryList = this.sort_table.GetSortData();
        // recupérer  data
    }

    todo_delivery_list: any;
    GetClientDelivery(): void {
        this.transactions_service.GetDashboardInfos().then(result => {
            // console.log(result);
            // let list = result['livraison_client']['BLC']; 
            //            for (let i=0; i<list.length; i++){
            //                let ref = list[i]['reference'].split('_');
            //                //console.log(ref);
            //                if(ref[0] === "BLC"){
            //                    this.tododelivery_list[i] = list[i];
            //                    this.sortedDataToDoDeliveryClientList[i] = list[i];
            //                    this.to_do_delivery_c = this.to_do_delivery_c + 1;
            //                }else{
            //                    this.current_delivery_c = this.current_delivery_c + 1;
            //                }
            //            }
            //           console.log(this.tododelivery_list);
            //           console.log(this.sortedDataToDoDeliveryClientList);
            if (result['livraison_client']['BRLC'] !== undefined) {
                this.tododelivery_list = result['livraison_client']['BRLC'];
                this.sortedDataToDoDeliveryClientList = result['livraison_client']['BRLC'];
                this.to_do_delivery_c = result['livraison_client']['BRLC'].length;
            }

            if (result['livraison_client']['BLC'] !== undefined) {
                this.current_delivery_c = result['livraison_client']['BLC'].length;
            }

            this.current_bcf = result['bcf'].length;
        });
    }

    stocktaking_ref: any;
    stocktaking_name: any;
    stocktaking_date: any;
    stocktaking_status: any;
    nothing: boolean = true;
    GetLastestStocktaking(): void {
        this.inventory_service.GetLastestStocktaking().then(result => {
            if (result['lastest_stocktaking'].length > 0) {
                this.nothing = false;
                this.stocktaking_ref = result['lastest_stocktaking'][0]['reference'];
                this.stocktaking_name = result['lastest_stocktaking'][0]['name'];
                this.stocktaking_date = result['lastest_stocktaking'][0]['starting_time'];
                this.stocktaking_status = result['lastest_stocktaking'][0]['status'];
            } else {
                this.nothing = true;
            }

        });
    }

    ngOnInit(): void {
        this.GetClientDelivery();
        this.GetNotValidatePurchaseList();
        this.GetArticlesStockInfThershold();
        //this.GetValidateOutofWareList();
        this.GetLastestStocktaking();
        this.GetMovementHistoryList();
    }


}






// WEBPACK FOOTER //
// ./src/app/dashboard.component.ts